import { render, staticRenderFns } from "./DeepView.vue?vue&type=template&id=122a47b7"
import script from "./DeepView.vue?vue&type=script&lang=js"
export * from "./DeepView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports